export default __webpack_public_path__ + "static/media/brand10.4872614b.svg";